import React, { FC, useEffect, useState } from 'react';
import { Redirect, Switch, useHistory, useLocation } from 'react-router-dom';
import { ProjectInUserProfile } from 'api/user';
import { CustomerPage } from 'components/organisms/customer';
import {
  ProjectContext,
  useProjectContext,
} from 'components/organisms/customer/layout';
import { NotificationSettingsPage } from 'components/organisms/module-settings/notifications';
import { NotificationsHash } from 'components/organisms/notifications/drawer/transformer';
import {
  AttachmentWorkspace,
  OverlayComparison,
  SideBySideComapre,
} from 'components/pages/workspace';
import { RoutePaths } from 'constant';
// eslint-disable-next-line import/no-internal-modules
import { useProjectGlobalSubscription } from 'queries/project-global-conversation/project-global-conversation';
import { CustomSecureRoute as SecureRoute } from 'routes/custom-secure-route';
import { RespSpaceTabPage } from 'routes/responsive/resp-space-tab';
import { RespStatusUpdate } from 'routes/responsive/resp-status-update-content';
import { RespTaskDesc } from 'routes/responsive/resp-task-desc';
import { TaskDetailsPageResponsive } from 'routes/tasks/task-details-responsive';
import { usePending } from 'stores/notifications';
import { NotFound } from '../404';
import { SlackLandingPage } from '../settings/integrations/slack/slack-landing-page';
import { HomePage } from './home';
import { Notifications } from './notifications';
import { ProfileSetupModal } from './profile-setup-modal';
import { ProjectDependentRoutes } from './project';

const ProjectChatSubscription: FC<{ projectId: number }> = ({ projectId }) => {
  useProjectGlobalSubscription(projectId);

  return null;
};

const ProjectChat = () => {
  const { project } = useProjectContext();
  const { projectId } = project || {};

  if (!projectId) {
    return null;
  }

  return <ProjectChatSubscription projectId={projectId} />;
};

export const CustomerRoutes: FC = () => {
  const [project, setProject] = useState<null | ProjectInUserProfile>(null);
  const [pending, resetPending] = usePending();
  const location = useLocation();
  const { push } = useHistory();

  useEffect(() => {
    if (location.hash.includes(NotificationsHash)) {
      push({ pathname: RoutePaths.notifications });
    }
  }, [location.hash, push]);

  return (
    <ProjectContext.Provider value={{ project, setProject }}>
      <Switch>
        <SecureRoute
          path={RoutePaths.respSpacesTab}
          component={RespSpaceTabPage}
          exact
        />
        <SecureRoute
          path={RoutePaths.respStatusUpdate}
          component={RespStatusUpdate}
          exact
        />
        <SecureRoute
          path={RoutePaths.taskDesc}
          component={RespTaskDesc}
          exact
        />

        <SecureRoute
          path={RoutePaths.attachmentWorkspace}
          component={AttachmentWorkspace}
        />
        <SecureRoute
          path={RoutePaths.attachmentWorkspaceSideBySide}
          component={SideBySideComapre}
          exact
        />
        <SecureRoute
          path={RoutePaths.attachmentWorkspaceOverlay}
          component={OverlayComparison}
          exact
        />
        <CustomerPage>
          <SecureRoute path={RoutePaths.home} exact>
            <HomePage />
          </SecureRoute>
          <SecureRoute path={RoutePaths.companyTasks} exact>
            <HomePage />
          </SecureRoute>
          <SecureRoute path={RoutePaths.notifications} exact>
            <Notifications pending={pending} resetPending={resetPending} />
          </SecureRoute>
          <SecureRoute
            path={RoutePaths.slackIntegration}
            component={SlackLandingPage}
          />
          <SecureRoute path={RoutePaths.projects} exact>
            <Redirect to={RoutePaths.home} />
          </SecureRoute>
          <SecureRoute
            path={RoutePaths.projectDetail}
            component={ProjectDependentRoutes}
          />
          <SecureRoute
            path="/settings/notifications"
            component={NotificationSettingsPage}
          />
          <SecureRoute
            path={RoutePaths.taskDetailsResponsive}
            component={TaskDetailsPageResponsive}
            exact
          />
        </CustomerPage>

        <SecureRoute path="*">
          <NotFound />
        </SecureRoute>
      </Switch>
      <ProfileSetupModal />
      <ProjectChat />
    </ProjectContext.Provider>
  );
};
